import api from '@/services/api';

/**
 * Thin wrapper around /api/lms/live-events/ endpoints.
 * Do NOT prefix URLs with /api/ — the axios instance handles that.
 */
export default {
  list(params = {}) {
    return api.get('/lms/live-events/', { params }).then(r => r.data);
  },
  get(id) {
    return api.get(`/lms/live-events/${id}/`).then(r => r.data);
  },
  create(payload) {
    return api.post('/lms/live-events/', payload).then(r => r.data);
  },
  update(id, payload) {
    return api.patch(`/lms/live-events/${id}/`, payload).then(r => r.data);
  },
  cancel(id) {
    return api.delete(`/lms/live-events/${id}/`);
  },
  /**
   * Mint a LiveKit token for the current user. Returns:
   * { token, ws_url, room, identity, role, expires_at, provider, event }
   */
  join(id) {
    return api.post(`/lms/live-events/${id}/join/`).then(r => r.data);
  },
  start(id) {
    return api.post(`/lms/live-events/${id}/start/`).then(r => r.data);
  },
  end(id) {
    return api.post(`/lms/live-events/${id}/end/`).then(r => r.data);
  },
  /**
   * Viewer heartbeat. Call every ~10s with how many seconds of video the
   * user has actually watched since the last heartbeat.
   */
  heartbeat(id, deltaSeconds, attendedLive = true) {
    return api.post(`/lms/live-events/${id}/heartbeat/`, {
      delta_seconds: deltaSeconds,
      attended_live: attendedLive,
    }).then(r => r.data);
  },
  messages(id) {
    return api.get(`/lms/live-events/${id}/messages/`).then(r => r.data);
  },
  postMessage(id, body, kind = 'chat', parent = null) {
    return api.post(`/lms/live-events/${id}/messages/`, { body, kind, parent }).then(r => r.data);
  },
  attendance(id) {
    return api.get(`/lms/live-events/${id}/attendance/`).then(r => r.data);
  },
};
